import React from 'react'
import './main.css'

const InvestigationForm = () => {

    return (
        <div className="jotForm">
            <iframe
            id="JotFormIFrame-212503873701450"
            title="Investigation Form"
            allow="geolocation; microphone; camera"
            src="https://form.jotform.com/212503873701450"
            frameBorder="0"
            style={{minWidth: '100%', height: '80vh', border: 'none', scrolling: 'none'}}
            />
        </div>
    )
}

export default InvestigationForm
